import { createWidget } from '@funtech-int/rival';

import { ChannelPromoBlockProps } from './components/ChannelPromoBlock/ChannelPromoBlock';

export const channelPromoBlockWidget = createWidget<unknown, ChannelPromoBlockProps>();
